<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,computed } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import TextBox from "../../../compositions/TextBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import DashboardSummaryComponent from "./SummaryType/DashboardSummaryComponent.vue";
import DashboardRealEstateComponent from "./SummaryType/DashboardRealEstateComponent.vue";
import DashboardStockControlComponent from "./SummaryType/DashboardStockControlComponent.vue";
import DashboardWasteComponent from "./SummaryType/DashboardWasteComponent.vue";
import DashboardWholesalerComponent from "./SummaryType/DashboardWholesalerComponent.vue";
import DashboardPackComponent from "./SummaryType/DashboardPackComponent.vue";
import DashboardReportComponent from "./SummaryType/DashboardReportComponent.vue";
import config from "../../../config.js";
import { errorAlert } from "../../../plugins/alert";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';
import moment from "moment";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '採用品名を入力';
        }
    }
})


const activeTab = ref(0);
const activeTabs = [
  {id:0,tab_name:"サマリ"},
  {id:1,tab_name:"卸別"},
  {id:2,tab_name:"小分け"},
  {id:3,tab_name:"不動品"},
  {id:4,tab_name:"廃棄"},
  {id:5,tab_name:"棚卸後差分"},
  {id:6,tab_name:"報告内容"},
]

const dashboardHeader = ref();
const dashboardTab = ref();
const searchWord = ref('');
const pharmacyIds = reactive([0]);
const medicineIds = reactive([0]);
const pharmacyOptions = reactive([]);
const medicineOptions = reactive([]);
const searchDateFrom = ref(moment(new Date()).format('YYYY-MM-01'));
const searchDateTo = ref('');
const drugTypes = reactive([]);
const searchParams = reactive({
    'page_size':30,
    'medicine_ids':medicineIds,
    'pharmacy_ids':pharmacyIds,
    'search_date_from':searchDateFrom.value,
    'search_date_to':searchDateTo.value,
    'medicine_type':0,
    'reload_count':0,
});
for (let i=0;i<Object.keys(config.DRUG_TYPES).length;i++) {
  searchParams[Object.keys(config.DRUG_TYPES)[i]] = 0;
}
const listSearch = () => {
    //日付チェックする
    if (searchDateFrom.value.length > 10) {
        errorAlert('不正な日付です。');
        return;
    }
    if (searchDateTo.value.length > 10) {
        errorAlert('不正な日付です。');
        return;
    }
    searchParams.medicine_ids = medicineIds;
    searchParams.pharmacy_ids = pharmacyIds;
    searchParams.search_date_from = searchDateFrom.value;
    searchParams.search_date_to = searchDateTo.value;
    searchParams.medicine_type = medicineType.value;
    for (let i=0;i<Object.keys(config.DRUG_TYPES).length;i++) {
        searchParams[Object.keys(config.DRUG_TYPES)[i]] = 0;
    }
    for (let i=0;i<drugTypes.length;i++) {
        searchParams[drugTypes[i]] = 1;
    }
}
const onSearchDateFromChange = (value) => {
  searchDateFrom.value = value;
  listSearch();
}
const onSearchDateToChange = (value) => {
  searchDateTo.value = value;
  listSearch();
}
const clearDate = () => {
  searchDateFrom.value = '';
  searchDateTo.value = '';
  listSearch();
}
const onPharmacySelectChange = (values) => {
    pharmacyIds.splice(0);
    for (let i=0;i<values.length;i++) {
        pharmacyIds.push(values[i]);
    }
    if (pharmacyIds.length == 0) {
        pharmacyIds.push(0);
    }
    listSearch();
}
const onMedicineSelectChange = (values) => {
    medicineIds.splice(0);
    for (let i=0;i<values.length;i++) {
        medicineIds.push(values[i]);
    }
    if (medicineIds.length == 0) {
        medicineIds.push(0);
    }
    listSearch();
}
const onClickReload = () => {
    searchParams['reload_count']++;
    listSearch();
}
onMounted(() => {
  dashboardHeader.value.style.top = String(document.getElementById('header').getBoundingClientRect().height) + 'px';
  dashboardTab.value.style.top = String(document.getElementById('header').getBoundingClientRect().height + dashboardHeader.value.getBoundingClientRect().height) + 'px';
});

const onChangeDrugType = (value,option) => {
  if (value) {
    if (drugTypes.indexOf(option.drug_type) == -1) {
      drugTypes.push(option.drug_type);
    }
  } else {
    if (drugTypes.indexOf(option.drug_type) != -1) {
      drugTypes.splice(drugTypes.indexOf(option.drug_type),1);
    }
  }
  listSearch();
}
const checkDrugType = computed(() => {
  return (drug_type) => {
    return drugTypes.indexOf(drug_type) == -1 ? false : true;
  }
})
const medicineType = ref(0);
const onChangeMedicineType = (value) => {
    medicineType.value = value;
    listSearch();
}
const medicineTypes = computed(() => {
    let result = [];
    //その他に医療材料は含める
    result.push({
        id:config.MEDICINE_TYPES['メディコード医薬品'],
        name:'メディコード医薬品',
    });
    result.push({
        id:config.MEDICINE_TYPES['OTC・雑貨'],
        name:'その他',
    });
    return result;
})

</script>

<style scoped>
.active {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(242 140 31 / var(--tw-border-opacity));
  border-bottom-width: 2px;
}
.active > svg {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
a.active:hover {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
.active > svg:hover {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
</style>
<template>
<div ref="element" class="relative">
    <div ref="dashboardHeader" class="sticky z-40 top-0 left-0 w-full flex flex-wrap items-center justify-end p-2 bg-gray-100 rounded">
        <div class="absolute top-2 left-2" style="z-index:41;">
            <help-action
            help-key="dashboard_help"
            ></help-action>
        </div>
        <div class="mr-2">
            <select-box
                :on-change="onChangeMedicineType"
                :value="medicineType"
                :options="medicineTypes"
                :is-searchable="false"
                list-height="20em"
            ></select-box>
        </div>
        <div v-for="drug_type in Object.keys(config.DRUG_TYPES)" :key="drug_type" class="mr-1">
            <check-box
            :label="config.DRUG_TYPES[drug_type]"
            :value="checkDrugType(drug_type)"
            :value-options="{drug_type:drug_type}"
            :on-change="onChangeDrugType"
            ></check-box>
        </div>
        <div class="m-1 flex flex-row items-center">
            <div class="mr-1">
                <text-box
                    :value="searchDateFrom"
                    type="date"
                    :on-change="onSearchDateFromChange"
                    place-holder="日付を入力"
                ></text-box>
            </div>
            <div class="tex-lg mr-1">~</div>
            <div class="mr-1">
                <text-box
                    :value="searchDateTo"
                    type="date"
                    :on-change="onSearchDateToChange"
                    place-holder="日付を入力"
                ></text-box>
            </div>
            <div>
                <a @click="clearDate" class="block cursor-pointer m-1 text-lg text-red-500"><i class="fa-solid fa-calendar-xmark"></i></a>
            </div>
        </div>
        <div class="m-1">
            <select-box
                :api-url="apis.pharmacy_group_medicine_list"
                :on-change="onMedicineSelectChange"
                :value="medicineIds"
                list-field-name="product_detail_name"
                :options="medicineOptions"
                :is-multi="true"
                place-holder="採用品を選択"
                list-height="20em"
            ></select-box>
        </div>
        <div class="m-1">
            <select-box
                :api-url="apis.pharmacy_group_member_list"
                :on-change="onPharmacySelectChange"
                :value="pharmacyIds"
                list-field-name="pharmacy_name"
                :options="pharmacyOptions"
                :is-multi="true"
                place-holder="店舗絞り込み"
            ></select-box>
        </div>
        <div class="m-1 mr-2">
            <button class="text-sm bg-amber-500 hover:bg-amber-700 text-white font-bold py-1 px-2 border border-amber-500 rounded" @click="onClickReload"><i class="fa-solid fa-arrow-rotate-right"></i> 再読み込み</button>
        </div>
    </div>
    <div ref="dashboardTab" class="sticky left-0 z-30 bg-white border-b border-gray-200 dark:border-gray-700">
        <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
            <li class="mr-2" v-for="tab in activeTabs" :key="tab.id">
                <a href="javascript:void(0)" @click="activeTab = tab.id" :class="(activeTab == tab.id ? 'active ' : '') + 'inline-flex p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group'">
                    {{ tab.tab_name }}
                </a>
            </li>
        </ul>
    </div>
    <div class="pr-4">
        <dashboard-summary-component
            :apis="apis"
            :is-visible="activeTab == 0"
            :search-params="searchParams"
        ></dashboard-summary-component>
        <dashboard-wholesaler-component
            :apis="apis"
            :is-visible="activeTab == 1"
            :search-params="searchParams"
        ></dashboard-wholesaler-component>
        <dashboard-pack-component
            :apis="apis"
            :is-visible="activeTab == 2"
            :search-params="searchParams"
        ></dashboard-pack-component>
        <dashboard-real-estate-component
            :apis="apis"
            :is-visible="activeTab == 3"
            :search-params="searchParams"
        ></dashboard-real-estate-component>
        <dashboard-waste-component
            :apis="apis"
            :is-visible="activeTab == 4"
            :search-params="searchParams"
        ></dashboard-waste-component>
        <dashboard-stock-control-component
            :apis="apis"
            :is-visible="activeTab == 5"
            :search-params="searchParams"
        ></dashboard-stock-control-component>
        <dashboard-report-component
            :apis="apis"
            :is-visible="activeTab == 6"
            :search-params="searchParams"
        ></dashboard-report-component>
    </div>
</div>
</template>

